import React from 'react';
import { BsDownload } from 'react-icons/bs';
import { useWindowDimensions } from '../../../utils';
import { OnestBoldDefault, OnestNormalDefault } from '../../styled/TextComponents';
import { color_white, color_red_default, color_grey_ultra_light, color_grey_dark } from '../../../constants/colors';
import Config from '../../../Config';

const EmptyPreview = () => {
    const { width: screenWidth } = useWindowDimensions();
    return (
        <div
            style={{
                width: screenWidth > 530 ? 90 : (screenWidth - 80) / 2 - 10,
                height: screenWidth > 530 ? 70 : ((screenWidth - 80) / 2 - 10) / 1.28,
                borderRadius: 10,
                backgroundColor: color_grey_ultra_light,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        style={{
                            width: 4,
                            height: 4,
                            borderRadius: "50%",
                            backgroundColor: color_grey_dark,
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

const ImagePreview = ({ image_path }) => {
    const { width: screenWidth } = useWindowDimensions();
    return (
        <div
            style={{
                width: screenWidth > 530 ? 88 : (screenWidth - 80) / 2 - 14,
                height: screenWidth > 530 ? 68 : ((screenWidth - 80) / 2 - 14) / 1.28,
                borderRadius: 10,
                backgroundColor: color_grey_ultra_light,
                display: "flex",
                border: `1px solid ${color_grey_ultra_light}`,
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <img
                    style={{
                        width: screenWidth > 530 ? 90 : (screenWidth - 80) / 2 - 16,
                        height: screenWidth > 530 ? 70 : ((screenWidth - 80) / 2 - 16) / 1.28,
                        borderRadius: 10,
                        objectFit: "cover",
                        backgroundColor: color_grey_ultra_light,
                    }}
                    src={Config.CLOUD_ADDR + '/' + image_path}
                    alt={"fileImage"}
                />
        </div>
    );
};

const ViewLibraryFolderBlock = ({ name, libraryFilesData, onClick }) => {
    const { width: screenWidth } = useWindowDimensions();

    return (

        <div
            onClick={() => {
                onClick(name);
            }}
            style={{
                width: screenWidth > 530 ? 190 : screenWidth - 80,
                height: screenWidth > 530 ? 226 : "min-content",
                borderRadius: 20,
                display: "flex",
                flexDirection: "column",
                padding: 10,
                gap: 25,
                backgroundColor: color_white,
                alignItems: "center",
                cursor: "pointer",
            }}>

            {/* Show up to 4 previews */}
            <div style={{ 
                width: screenWidth > 530 ? 190 : screenWidth - 80,
                height:  "auto",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 10
            }}>
                {[0, 1, 2].map((i) =>
                    libraryFilesData[i] ?
                        <ImagePreview key={i} image_path={libraryFilesData[i].image_path} />
                        :
                        <EmptyPreview key={i} />
                )}
                <EmptyPreview key={3} />
            </div>
            <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 25,

            }}>
                <OnestNormalDefault>{name}</OnestNormalDefault>
            </div>
        </div>

    );
};

export default ViewLibraryFolderBlock;